import { mock, eventData } from '../../utils/mockdata';
// import { getUserProfile } from '@/store/actions/user';
var axios = require('axios');


export default {
    

    state: {
        events: [],
        selectedEvent: {}
    }, 
    getters: {
        allEvents: (state) => state.events,
        
        selectedEvent: (state) => state.selectedEvent
    },
    
    actions: {
        async fetchEvents({commit}) {
            // console.log("TODO > "+ getUserProfile.accountid)

            await mock.onGet('/events', { params: { accountid: '1' } }).reply(
                // ..getUserProfile.accountid
                
               200, {data: eventData}
              );
              
            await axios.get('/events', { params: { accountid: '1' } } )
            .then(resp => {
                commit('setEvents', resp.data.data),
                console.log("events fetched. > " + resp.data.data.length)
            });
            
        },
        async updateEvent({commit}, event) {
            commit('updateEvent', event)
        },
        putSelectedEvent({commit}, event) {
            commit('setSelectedEvent', event)
        },
        addNewEvent({commit}, event) {
            commit('addNewEvent', event)
        }, 
        deleteEvent({commit}, event) {
            commit('deleteEvent', event)
        }
    },
    mutations: {
        setEvents: (state, events) => (state.events = events),
        setSelectedEvent: (state, event) => (state.selectedEvent = event),
        updateEvent: (state, upditem) => {
            
            const index = state.events.findIndex(item => item.id == upditem.id)
            if (index !== -1) {
                state.events.splice(index, 1, upditem)
            }
            // console.log("... > "+ JSON.stringify(updevent))
        },
        addNewEvent: (state, additem) => {
            state.events.unshift(additem)
        },
        deleteEvent: (state, delitem) => {
            const index = state.events.findIndex(item => item.id == delitem.id)
            if (index !== -1) {
                state.events.splice(index, 1)
            }
        }
    },
    
}

